export type BlogArticleCategory =
  | 'sustainability'
  | 'compliance'
  | 'msme'
  | 'product'
  | 'industry'
  | 'general';

export type BlogArticleStatus = 'draft' | 'published' | 'archived';

export interface BlogArticle {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  body: string;
  category: BlogArticleCategory;
  tags: string[];
  coverImageUrl: string;
  featured: boolean;
  publishedAt?: string | null;
  createdAt?: string;
  updatedAt?: string;
  status?: BlogArticleStatus;
}

export interface BlogArticlePagination {
  current: number;
  pages: number;
  total: number;
}

export const BLOG_CATEGORY_LABELS: Record<BlogArticleCategory, string> = {
  sustainability: 'Sustainability',
  compliance: 'Compliance',
  msme: 'MSME',
  product: 'Product',
  industry: 'Industry',
  general: 'General',
};

export const formatArticleDate = (value?: string | null) => {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};
